import { render, staticRenderFns } from "./counterpartiesPaymentAccountsArchive.vue?vue&type=template&id=4bca2e0e"
import script from "./counterpartiesPaymentAccountsArchive.vue?vue&type=script&lang=js"
export * from "./counterpartiesPaymentAccountsArchive.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesPaymentAccountsArchive.vue?vue&type=style&index=0&id=4bca2e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports